import httpStore from "@/api/httpStore.js";

/**
 * Google Places Autocomplete
 * Fetches address predictions based on user input
 *
 * @param {string} input - The text string to search
 * @param {string} types - Type of results (default: 'address')
 * @param {string} components - Country restrictions (default: 'country:us|country:ca')
 * @returns {Promise} Promise with autocomplete predictions
 */
export function getAddressAutocomplete(
  input,
  types = "address",
  components = "country:us|country:ca"
) {
  return httpStore
    .get("google_places/autocomplete", {
      params: {
        input,
        types,
        components
      }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Google Places Details
 * Fetches detailed information about a specific place
 *
 * @param {string} placeId - The Google Place ID
 * @param {string} fields - Comma-separated list of fields
 * @returns {Promise} Promise with place details
 */
export function getPlaceDetails(
  placeId,
  fields = "address_components,formatted_address"
) {
  return httpStore
    .get("google_places/details", {
      params: {
        place_id: placeId,
        fields
      }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

/**
 * Geocode an address
 * Converts an address string to geographic coordinates
 *
 * @param {string} address - The address to geocode
 * @returns {Promise} Promise with geocoding results
 */
export function geocodeAddress(address) {
  return httpStore
    .get("google_places/geocode", {
      params: {
        address
      }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
